import React from 'react';
import { useSelector } from 'react-redux';
import { SystemText } from 'e4shared';
import Bullet from 'components/prism/bullet';
import { translateCourse } from 'helpers/translations';
import ProgressBar from '../progressBar';
import Skills from 'views/user/learnTracker/components/skills';

export const Course = ({ course, padBottom, noShadow, managerView }) => {
    const [showSkills, setShowSkills] = React.useState(false);

    const { user } = useSelector(state => state.user);

    course = translateCourse(user.language_Code, course);

    const text = {
        resume: SystemText('General/Resume'), //Resume
        start: SystemText('General/Start'), //Start
        review: SystemText('General/ReviewCourse'), //Review
    };

    const contents = (
        <>
            <div className="prism-banner-float flex flex-center">
                <Bullet type="course" />
            </div>
            <div className="prism-banner">
                <img src="/dist/img/defaults/course-default.jpg" />
            </div>
            <div className="prism-content flex flex-column">
                {course?.status === 'in_progress' && <ProgressBar progress={course?.progress} />}
                <h3>{course?.name}</h3>
                <div className="flex-grow">{course?.description && <p className="truncate-4">{course.description}</p>}</div>
                {course.status === 'completed' && (
                    <div className="flex flex-center">
                        <div className="flex-grow">
                            <Bullet
                                value={SystemText('Controls/CompletedObjective/Complete')}
                                icon="badge-check"
                                style="success"
                            />
                        </div>
                    </div>
                )}
                <div className="flex flex-center">
                    <div className="flex-grow">
                        {!managerView && (
                            <button className="btn btn-primary">
                                {course.progress === 100 ? text.review : course.progress ? text.resume : text.start}
                            </button>
                        )}
                    </div>
                    {course.status === 'completed' && course.skills && (
                        <button
                            className="btn btn-cornered btn-tertiary btn-round ml5"
                            onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowSkills(course);
                            }}
                        >
                            {SystemText('General/ViewResults')}
                        </button>
                    )}
                </div>
            </div>
        </>
    );

    const css = `prism-content-box anchor-top ${padBottom ? 'mb10' : ''} ${noShadow ? 'no-shadow' : ''}`;

    return (
        <>
            {managerView ? (
                <div data-testid="course-item" className={css}>
                    {contents}
                </div>
            ) : (
                <a href={course.url || '#'} data-testid="course-item" className={css}>
                    {contents}
                </a>
            )}
            <Skills show={showSkills} close={() => setShowSkills(false)} hideBehaviour />
        </>
    );
};

export default Course;
